import { clientService } from "../services/clientService";
import { useAsyncData } from "./useAsyncData";

export function useClientDetail(tenantId?: string | null, clientId?: string) {
  return useAsyncData(
    () =>
      tenantId && clientId
        ? clientService.getClient(tenantId, clientId)
        : Promise.reject(new Error("No client selected.")),
    [tenantId, clientId],
  );
}
